<div class="stat-cards row row-cols-xl-4 row-cols-lg-3 g-4" *ngIf="businessListData.length>0 && !loader">
  <div class="col" *ngFor="let item of businessListData" >
    <mat-card appearance="outlined" (click)="viewDetails(item)" class="stats_c">
      <mat-card-title-group class="align-items-center">
        <mat-card-title>{{item.entityName}}</mat-card-title>
        <mat-card-subtitle class="m-0" *ngIf="item.addressInfo">{{
          item.addressInfo.address_line.length > 40
            ? item.addressInfo.address_line.substring(0, 40) + "..."
            : item.addressInfo.address_line
        }}</mat-card-subtitle>
        <mat-card-subtitle class="m-0" *ngIf="!item.addressInfo">No address Info</mat-card-subtitle>
       
        <mat-card-subtitle style="margin-bottom: 0px; margin-top: 10px;">{{item.shopBooking}} {{'dashboard_cards.shop_bookings' | translate}}</mat-card-subtitle>
        <mat-card-subtitle class="m-0">{{item.homeBooking}} {{'dashboard_cards.home_bookings' | translate}}</mat-card-subtitle>
        <!-- <div class="card-icon d-flex justify-content-center align-items-center">
          <img [src]="item.imageThumbUrl" alt="" onerror="this.src='../../../../assets/images/salon_support_header.png'">
        </div> -->
        <div class="card-icon d-flex justify-content-center align-items-center">
          <div class="image-container">
            <img [src]="item.imageThumbUrl" alt="" onerror="this.src='../../../../assets/images/entity_placeholder.png'">
            <div class="status-dot" *ngIf="item.isActive == 0">
              <mat-icon class="material-icons-outlined" style="color: #fafafa;
              font-size: 1.65rem;"
              >warning</mat-icon>
            </div>
          </div>
        </div>
        
      </mat-card-title-group>
    </mat-card>
  </div>
  
 
</div>
<div class="stat-cards row row-cols-xl-1 row-cols-lg-12 g-4" *ngIf="businessListData.length==0 && !loader">
  <div class="col"  >
    <mat-card  appearance="outlined"  class="stats_c">
      <mat-card-title-group class="align-items-center" style="display: block; text-align: center; margin: 20px 0px;">
        <mat-card-title>No business added yet.</mat-card-title>
       
        <mat-card-subtitle class="m-0"> <button mat-flat-button color="accent" (click)="createNewBusiness()">
          Create new business
          <mat-icon class="material-icons-round" [inline]="true"
            >add_circle</mat-icon
          >
        </button></mat-card-subtitle>
       
        <!-- <mat-card-subtitle style="margin-bottom: 0px; margin-top: 10px;">{{item.shopBooking}} {{'dashboard_cards.shop_bookings' | translate}}</mat-card-subtitle> -->
        <!-- <mat-card-subtitle class="m-0">{{item.homeBooking}} {{'dashboard_cards.home_bookings' | translate}}</mat-card-subtitle> -->
        <!-- <div class="card-icon d-flex justify-content-center align-items-center">
          <img [src]="item.imageThumbUrl" alt="" onerror="this.src='../../../../assets/images/salon_support_header.png'">
        </div> -->
        
      </mat-card-title-group>
    </mat-card>
  </div>
  
 
</div>
